import { t } from '@lingui/core/macro';
import { Box, type BoxProps, Button } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import MenuPopover, { type MenuPopoverProps } from 'components/table/TableMoreMenu/MenuPopover';
import { cloneElement, type ReactElement, type ReactNode, useState } from 'react';
import { MoreVerticalIconMUI } from './icons/MoreVerticalIconMUI';

type Props = {
  children: ReactNode;
  button?: ReactElement<{ onClick?: React.MouseEventHandler<HTMLElement> }>;
  sx?: BoxProps['sx'];
  withDividers?: boolean;
  popoverProps?: Partial<MenuPopoverProps>;
};

export const MoreActionsMenu = ({ children, button, sx, withDividers, popoverProps }: Props) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const isOpen = Boolean(anchorEl);
  const theme = useTheme();

  const openMenu = (e: React.MouseEvent<HTMLElement>) => setAnchorEl(e.currentTarget);
  const closeMenu = () => setAnchorEl(null);

  return (
    <Box display="flex" flexWrap="wrap" sx={sx}>
      {button ? (
        cloneElement(button, { onClick: openMenu })
      ) : (
        <Button
          onClick={openMenu}
          sx={{ color: theme.palette.grey[600], minWidth: 0 }}
          aria-label={t`Plus d’actions`}
        >
          <MoreVerticalIconMUI />
        </Button>
      )}
      <MenuPopover
        open={isOpen}
        anchorEl={anchorEl}
        onClose={closeMenu}
        onClick={closeMenu}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        sx={{ mt: 1, width: 'fit-content' }}
        withDividers={withDividers}
        {...popoverProps}
      >
        {children}
      </MenuPopover>
    </Box>
  );
};
